import React from 'react';

import TextField from '../../../../forms/TextField';

interface DurationProps {
  label?: string;
  readOnly?: boolean;
}

export default function Duration({ label = 'Video Duration (Seconds)', readOnly = false }: DurationProps) {
  return (
    <TextField
      label={label}
      name="videoAd.duration"
      inputProps={{ readOnly }}
      rules={{
        required: 'Please enter a duration.',
      }}
    />
  );
}
